import React from "react";
import {
  FormControlLabel,
  Typography,
  Button,
  Checkbox,
  FormGroup,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
function ViewResult() {
  return (
    <>
      <Typography  align="center">
      SKT 본인확인 이용 약관
제1조 (목적)
이 약관은 본인확인서비스를 제공하는 에스케이텔레콤 주식회사(이하 "회사"라 합니다)와 본인확인서비스 이용자(이하 "이용자"라 합니다)간에 본인확인서비스 이용에 관한 회사와 이용자의 권리와 의무, 기타 제반 사항을 정함을 목적으로 합니다.
제2조 (용어의 정의)
① "본인확인서비스"라 함은 이용자가 유무선 인터넷 웹사이트 및 스마트폰 Application 등(이하 "사이트"라 합니다)에서 본인 명의로 개통한 휴대폰을 이용하여, 본인확인정보를 입력하고 인증 절차를 통하여 본인 여부와 본인이 등록한 정보의 정확성을 확인하여 주는 서비스를 말합니다.
② "본인확인정보"라 함은 본인확인을 위하여 이용자가 입력한 본인의 생년월일, 성별, 성명, 내/외국인 여부, 본인명의로 개통된 이동전화번호, 기타 회사와 이용자간에 별도로 설정한 번호 등 이용자에 대한 본인확인서비스 제공을 위해 필요한 정보를 말합니다.
③ "이용자"라 함은 사이트에서 회사가 제공하는 본인확인서비스를 이용하는 자를 말합니다.
④ "중복가입확인정보"라 함은 이용자가 사이트에 가입하거나 사이트에서 특정 서비스 이용, 구매 등 어떤 행동을 할 때, 해당 이용자의 기 가입/이용 여부를 확인하기 위하여 생성되는 정보를 말합니다.
⑤ "본인확인기관"이라 함은 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 본인확인서비스 관련 법령에 따라 주민등록번호를 수집 • 이용하고, 사이트에서 주민등록번호를 사용하지 아니하고 본인을 확인할 수 있도록 해주는 방법(이하 "대체수단"이라 합니다)을 개발 • 제공 • 관리하는 업무를 담당하는 사업자를 말합니다.
⑥ "연계 식별정보"라 함은 이용자가 가입/등록한 사이트들간의 서비스 또는 Contents, point등의 연계, 정산 등의 목적으로 사이트에 가입/등록한 이용자를 식별하기 위하여 생성되는 정보를 말합니다.
⑦ "대행기관"은 이용자가 사이트에서 본인확인서비스를 제공받을 수 있도록, 사이트와 회사간의 본인확인서비스를 중계하고 이용자에게 본인확인서비스 이용방법의 안내와 문의 등 지원업무를 담당하는 등, 회사가 위탁한 업무범위내에서 회사를 대신하여 이용자에게 본인확인서비스와 관련된 업무를 제공하는 사업자를 말합니다.
⑧ "사이트"라 함은 유무선 인터넷 웹사이트, 스마트폰 Application 등을 통하여 이용자에게 상품, 서비스, Contents, Point 등 각종 재화와 용역을 유/무료로 제공하는 개인, 법인, 기관, 단체 등을 말합니다.
⑨ "접근매체"란 본인확인서비스 이용을 위해 이용자 및 이용자가 입력하는 내용 등의진실성과 정확성을 담보하는 수단으로서, 이용자가 입력하는 제2항의 정보, I-PIN ID 및 Password 등 본인확인기관에서 발급받은 정보, 기타 이용자가 회사 및 사이트에서 설정한 ID 및 Password 등의 정보, 이용자 명의의 이동전화 번호 등을 말합니다.
⑩ "대체수단"이라 함은 중복가입확인정보 및 연계식별정보를 포함하여, 주민등록정보를 사용하지 아니하고 본인여부를 식별 및 확인할 수 있는 수단을 말합니다.
제3조 (약관의 명시 및 변경)
① 회사는 이 약관을 회사가 운영하는 사이트 등에 게시하거나 이용자의 본인확인서비스 이용시 공개하여 이용자가 이 약관의 내용을 확인할 수 있도록 합니다. 또한 이용자의 요청이 있는 경우 전자문서의 형태로 약관 사본을 이용자에게 교부합니다.
② 회사는 필요하다고 인정되는 경우 이 약관을 변경할 수 있으며, 회사가 약관을 변경할 경우에는 적용일자 및 변경사유를 명시하여 회사가 운영하는 사이트에서 적용일자 15일 전부터 공지합니다.
③ 회사가 전항에 따라 변경 약관을 공지 또는 통지하면서 이용자에게 약관 변경 적용일 까지 거부의사를 표시하지 않으면 약관의 변경에 동의한 것으로 간주한다는 내용을 명확하게 공지 또는 통지하였음에도 이용자가 명시적으로 약관 변경에 대한 거부의사를 표시하지 아니하면 이용자가 변경 약관에 동의한 것으로 간주합니다. 이용자는 변경된 약관 사항에 동의하지 않으면 본인확인서비스 이용을 중단하고 이용 계약을 해지할 수 있습니다.
④ 이용자 또는 사이트가 이 약관의 내용(약관 변경시 변경된 내용 포함)을 알지 못하여 발생하는 손해 및 피해에 대해서는 회사는 일체 책임을 지지 않습니다.
제4조 (이용 계약의 성립)
이용자가 사이트 등에 게시되거나 본인확인서비스 이용시 공개되는 이 약관의 내용에 "동의" 버튼을 누르거나 체크하면 약관에 동의하고, 본인확인서비스 이용을 신청한 것으로 간주합니다.
제5조 (본인확인정보 및 접근매체의 관리 등)
① 회사는 본인확인서비스 제공시 이용자가 사용한 접근매체와 입력된 본인확인정보, 사이트에서 제공하는 정보 등을 이용하여, 이용자의 신원, 권한 및 본인확인서비스를 요청한 내역 등을 확인 할 수 있습니다.
② 이용자는 자신의 본인확인 정보 및 접근매체를 제3자에게 대여하거나 사용을 위임하거나 양도 또는 담보 목적으로 제공할 수 없으며, 본인확인정보 및 접근매체의 도용이나 위조 • 변조 등을 방지하기 위해 충분한 주의를 기울여야 합니다.
③ 이용자는 자신의 본인확인정보 및 접근매체를 제3자에게 누설 또는 노출하거나 방치하여서는 안됩니다.
④ 이용자는 접근매체의 분실 • 도난 • 유출 • 위조 • 변조 등 또는 본인확인정보 유출 등의 사실을 인지할 경우 회사에 즉시 통지하여야 하며, 회사는 이용자의 통지를 받은 때부터 즉시 본인확인서비스를 중지합니다.
제6조 (본인확인서비스 안내)
① 회사가 제공하는 본인확인서비스는, 이용자가 입력한 본인확인정보에 대해, 이용자가 본인 명의로 개통하고 사용하고 있는 이동전화 서비스 관련 정보 • 중복가입확인정보 • 연계 식별정보를 이용하여, 본인 식별 또는 본인의 성년 • 미성년 여부, 중복가입여부 등을 확인하여주는 서비스 입니다.
② 회사는 직접 또는 대행기관을 통하여 사이트에, 서비스 화면 또는 Socket형태로 본인확인서비스를 제공하며, 사이트는 사이트 운영과 관련된 법령과 사이트 이용약관에 따라 이용자에게 본인확인서비스 이용 수단을 제공합니다.
③ 이용자는 특정 사이트에서 회사 및 대행기관의 이용약관, 사이트의 이용약관에 동의하는 경우, 해당 사이트에서 회사가 제공하는 본인확인서비스를 이용하실 수 있습니다.
④ 제3항에 따라 각 이용약관에 동의한 경우, 이용자가 자신의 생년월일, 성명, 성별, 내/외국인, 본인 명의로 가입한 이동통신사와 이동전화 번호 등의 정보를 입력하고, 입력한 정보가 일치하는 경우에 이용자의 이동전화 번호로 송신되는 1회성 비밀번호(승인번호)를 정확하게 입력하는 것으로 본인 확인이 이루어 집니다. 단, 회사가 직접 운영하는 사이트 또는 관련 법령 등에 따라 주민등록번호의 수집 • 이용이 허용되는 사이트에서는 생년월일 대신 주민등록번호를 받을 수 있습니다.
⑤ 제4항에 따라 본인확인이 완료된 이용자에 대해서는 해당 이용자의 본인확인정보, 중복가입확인정보 및 연계 식별정보를 회사가 보유하고 있는 경우, 사이트의 요청에 따라 사이트에 제공될 수 있으며, 제공된 정보는 각 사이트가 이용자와 체결한 약관, 계약에 따라 운영 • 관리 • 폐기됩니다.
제7조 (대체수단의 생성 및 제공)
① 회사는 이용자의 이동전화 가입시 수집한 주민등록번호를 토대로 대체수단을 생성하고 사이트에 제공할 수 있습니다.
② 회사의 대체수단 생성 및 제공방법은 다음 각 호와 같습니다.
1. 이용자의 이동전화 가입시, 제3의 본인확인기관에 실명 사용여부를 질의하고, 이에 따라 대체수단을 받아와서 저장하는 방법
2. 이용자의 본인확인서비스 이용시, 제3의 본인확인기관간의 합의를 통하여 비밀번호 등 대체수단 규격을 정한 후, 이에 따라 회사가 생성하거나 제3의 본인확인기관으로부터 제공받는 방법
3. 이용자의 본인확인서비스 이용시, 해당 이용자의 이동전화가입시 회사가 제공받은 주민등록번호와 해당 이용자가 이용하고 있는 사이트의 일련번호를 제3의 본인확인기관에 제공하고, 이에 해당되는 대체수단을 받아와서 제공하는 방법
③ 제1항 제3호에 따라 회사가 제3의 본인확인기관으로부터 대체수단을 제공받은 경우, 해당 대체수단의 정확성 유무에 대해서는 회사가 책임지지 않습니다.
제8조 (본인확인서비스 제공시간)
① 본인확인서비스의 이용은 연중무휴 1일 24시간을 원칙으로 합니다. 다만, 정기 점검 및 기타 기술상의 이유, 기타 운영상의 사유와 목적에 따라 회사가 정한 기간에 일시 중지될 수 있으며, 각 사이트의 기술상, 운영상의 사유와 목적에 따라 일시 중지될 수 있습니다.
② 회사는 본인확인서비스 중지에 따라 이용자에게 별도의 보상은 하지 않습니다. 단 본인확인서비스를 이용기간에 따라 정액제 형태로 유료 판매하는 경우, 정액제 유료 이용자에게는 중지시간이 24시간을 초과한 경우에 한하여, 월 이용금액을 해당월의 날짜 수로 일할 계산하여 환불 또는 차감하며, 이용금액의 과금 당사자가 회사인 경우에는 회사가, 대행기관인 경우에는 대행기관이 환불 또는 차감하여 드립니다.
제9조 (회사의 권리와 의무)
① 회사가 접근매체의 발급주체가 아닌 경우에는 접근매체의 위조 • 변조 • 누설 등으로 인해 이용자에게 발생한 손해에 대하여 배상책임이 없습니다.
② 이용자가 제5조 제2항 내지 제4항의 내용을 준수하지 아니하거나, 회사가 부정사용 여부를 확인할 수 없는 접근매체 또는 본인확인정보의 이용으로 인해 발생한 이용자의 손해에 대하여 회사는 배상책임이 없습니다.
③ 회사는 본인확인서비스 제공과 관련하여 인지한 이용자의 본인확인정보를 본인의 승낙 없이 제3자에게 누설하거나 배포하지 않습니다. 단, 국가기관의 요구가 있는 경우, 범죄에 대한 수사상의 목적이 있는 경우 등 관계 법령에서 정한 절차에 따른 요청이 있는 경우에는 그러하지 않습니다.
④ 회사는 이용자에게 안정적인 본인확인서비스 제공을 위하여 지속적으로 관련 시스템이나 절차, 기능 등의 예방점검, 유지보수 등을 이행하며, 본인확인서비스의 장애가 발생하는 경우, 이를 지체 없이 수리 및 복구합니다.
⑤ 회사는 복제폰, 대포폰, 휴대폰 소액대출(일명 휴대폰깡) 등 시장 질서를 교란시키는 불법행위에 의한 피해 방지를 위하여 불법행위가 의심되는 이용자 또는 회선에 대한 본인확인서비스 이용을 제한하거나 중지하는 것은 물론, 관계 법령에 따라 행정 및 사법기관에 수사를 의뢰할 수 있습니다.
⑥ 회사는 회사가 제공하는 이동전화 등 통신역무의 요금을 정상적으로 납부하지 않거나 일부 특수 요금제에 가입한 이용자에 대하여 본인확인서비스 이용을 제한할 수 있습니다.
⑦ 회사는 이용자가 회사의 이동전화 등 통신역무 이용을 위해 제출한 가입신청서 또는 이와 관련된 본인확인 절차가, 명의도용, 관련 서류 위 • 변조 등 위법 행위가 개입된 사실을 확인하는 즉시 해당 이용자 및 회선에 대한 본인확인서비스 제공을 중지하며, 해당 이용자와 회선에 대해 관련 법령 및 통신역무 이용약관에 따른 조치를 취할 수 있습니다.
제10조 (이용자의 권리와 의무)
① 이용자는 본인확인서비스를 이용함에 있어서 다음 각 호에 해당하는 행위를 하여서는 안되며, 회사는 이용자의 다음 각 호의 행위에 대해 일체의 법적 책임을 지지 않습니다.
1. 본인이 아닌 타인의 본인확인정보를 부정하게 사용 및 도용하는 행위
2. 회사 및 대행기관, 사이트의 저작권, 제3자의 저작권 등 기타 권리를 침해하는 행위
3. 법령에 규정하는 제반 범죄 및 위법 행위
4. 이 약관에 규정된 이용자의 의무 또는 준수사항을 위반하는 행위
② 이용자는 이 약관에서 규정하는 사항과 본인확인서비스에 대한 이용안내 또는 주의사항 등을 준수하여야 합니다.
③ 이용자는 제5조의 의무를 이행하여야 합니다.
④ 이용자는 회사가 운영하는 사이트(T world, www.tworld.co.kr)를 통하여 자신의 본인확인서비스 이용내역을 확인할 수 있으며, 관련 문의를 회사의 고객센터를 통하여 할 수 있습니다.
《 회사의 고객센터 연락처 : 이동전화 114(무료), 국번 없이 1599-0011(유료) 》
제11조 (이용자 정보의 제공 범위)
① 회사는 본인확인서비스를 제공함에 있어 취득한 이용자의 정보를 이용자의 동의 없이 제3자에게 제공, 누설하거나 업무상 목적 외에 사용하지 않습니다.
② 이용자가 개인정보의 수집 • 이용 • 제공에 동의하고 이용하는 사이트 또는 신용카드사 등 제3자가, 이용자의 이동전화 번호 및 해당 사이트 • 신용카드사 등 제3자가 보유한 대체수단의 진실성 여부를 회사에 대해 확인할 경우, 회사는 해당 이동전화 번호 및 대체수단의 진실성 여부를, 확인을 요청한 사이트 또는 신용카드사 등 제3자에게 회신할 수 있습니다.
제12조 (본인확인서비스의 안정성 확보)
① 회사는 본인확인서비스의 안전성과 신뢰성, 보안성을 확보하기 위하여 해킹방지시스템 및 보안관리 체계 구성, 접근제한 등 기술적, 관리적 조치를 취합니다.
② 회사는 본인확인서비스 관련 서버 및 통신기기의 정상작동여부 확인을 위하여 정보처리시스템 자원 상태의 감시, 경고 및 제어가 가능한 모니터링 체계를 갖춥니다.
③ "회사"는 해킹 침해 방지를 위하여 다음 각 호의 시스템 및 프로그램을 설치하여 운영합니다.
1. 침입 차단 및 탐지시스템 설치
2. 그 밖에 필요한 보호장비 또는 암호프로그램 등 정보보호시스템 설치
④ "회사"는 컴퓨터바이러스 감염을 방지하기 위하여 바이러스 방지를 위한 방어, 탐색, 복구 절차를 자체적으로 운영합니다.
제13조 (이용자의 개인정보보호)
① 이용자의 개인정보 보호는 회사가 관련 법령과 회사가 수립하여 운영하는 개인정보 취급방침 등에 따릅니다. 자세한 회사의 개인정보 수집 • 이용 범위 등은 이동전화 가입신청서와 회사 대표 사이트(www.sktelecom.com)에서 제공되는 개인정보 취급방침을 참조하시기 바랍니다.
② 제1항의 개인정보 취급방침에서 정한 바 이외에, 회사는 본인확인서비스를 위하여 다음 각 호의 경우에 이용자 개인정보의 일부를 회사가 선정한 사업자에게 제공할 수 있습니다.
1. 이용자의 본인확인서비스 이용시 사이트가 필요로 하는 이용자 식별정보(중복가입확인정보, 대체수단)의 생성 및 관리, 제공을 위하여 이용자의 주민등록정보를 제3의 본인확인기관에게 제공할 수 있습니다.
2. 회사가 수집 또는 제공받은 개인정보(중복가입확인정보, 대체수단)는 회사 또는 대행기관을 통해 사이트에게 제공합니다.
3. 본인확인서비스를 위한 회사의 개인정보의 수집 • 이용 • 제공범위 및 개인정보의 취급을 위탁하는 수탁자와 위탁업무내용 등은 이 약관이 게시되는 화면에 별도로 링크하여 제공합니다.
제14조 (약관 외 준칙)
이 약관에 명시되지 아니한 사항에 대해서는 정보통신망 이용 촉진 및 정보보호 등에 관한 법률 등 기타 관련 법령 또는 상관례에 따릅니다.
제15조 (관할법원)
① 본인확인서비스 이용과 관련하여 회사와 이용자 사이에 분쟁이 발생한 경우, 회사와 이용자는 분쟁의 해결을 위해 성실히 협의합니다.
② 제1항의 협의에서도 분쟁이 해결되지 않을 경우 양 당사자는 민사소송법상의 관할 법원에 소를 제기할 수 있습니다.
부칙
(시행일) 이 약관은 공지한 날로부터 시행합니다. 단, 제10조 제4항은 2013년 5월30일부터 시행합니다.
Ⅰ. 본인확인서비스 이용을 위한 개인정보 수집/이용/취급위탁 동의 
본인은 SK텔레콤㈜(이하 ‘회사’라 합니다)가 제공하는 본인확인서비스(이하 ‘서비스’라 합니다)를 이용하기 위해, 다음과 같이 ‘회사’가 본인의 개인정보를 수집/이용하고, 개인정보의 취급을 위탁하는 것에 동의합니다. 
1. 수집항목 
- 이용자의 성명, 이동전화번호, 생년월일, 성별 
- 연계정보(CI), 중복가입확인정보(DI) 
- 이용자가 이용하는 웹사이트 또는 Application 정보 
2. 이용목적 
- 이용자가 웹사이트 또는 Application에 입력한 본인확인정보의 정확성 여부 확인(본인확인서비스 제공) 
- 해당 웹사이트 또는 Application에 연계정보(CI)/중복가입확인정보(DI) 전송 
- 서비스 관련 상담 및 불만 처리 등 
3. 개인정보의 보유기간 및 이용기간 
- 이용자가 서비스를 이용하는 기간에 한하여 보유 및 이용. 다만, 아래의 경우는 제외 
- 법령에서 정하는 경우 해당 기간까지 보유(상세 사항은 회사의 개인정보취급방침에 기재된 바에 따름) 
4. 본인확인서비스 제공을 위한 개인정보의 취급위탁 
개인정보의 취급 위탁 수탁자 ㈜다날, ㈜드림시큐리티, ㈜케이지모빌리언스, ㈜한국사이버결제, 한국모바일인증㈜, , 한국전화결제협회, 수미온㈜, SK플래닛㈜, 엠드림커뮤니케이션㈜ 
취급위탁 업무 본인확인정보의 정확성 여부 확인(본인확인서비스 제공), 연계정보(CI)/중복가입확인정보(DI) 전송, 서비스 관련 상담 및 불만 처리, 휴대폰인증보호 서비스 등 

5. 위 개인정보 수집∙이용 및 취급위탁에 동의하지 않으실 경우, 서비스를 이용하실 수 없습니다. 

※ 회사가 제공하는 서비스와 관련된 개인정보의 취급과 관련된 사항은, 회사의 개인정보취급방침(회사 홈페이지 www.sktelecom.com )에 따릅니다. 
Ⅱ. 본인확인서비스 이용을 위한 개인정보제공 동의 
본인은 SK텔레콤㈜(이하 ‘회사’라 합니다)가 제공하는 본인확인서비스(이하 ‘서비스’라 합니다)를 이용하기 위해, 다음과 같이 본인의 개인정보를 회사가 아래 기재된 제3자에게 제공하는 것에 동의합니다. 
1. 개인정보를 제공받는 자 
- NICE신용평가정보㈜, 서울신용평가㈜ 
2. 개인정보를 제공받는 자의 개인정보 이용목적 
- 연계정보(CI)/중복가입확인정보(DI) 생성 및 회사에 제공 
3. 제공하는 개인정보 항목 
- 회사가 보유하고 있는 이용자의 주민등록번호 
4. 개인정보를 제공받는 자의 개인정보 보유 및 이용기간 
- 연계정보(CI)/중복가입확인정보(DI) 생성 후 즉시 폐기 
5. 위 개인정보 제공에 동의하지 않으실 경우, 서비스를 이용할 수 없습니다. 

본인은 위 내용을 숙지하였으며 이에 동의합니다. 
















KT 본인확인 이용 약관

제1조 (목적)
본 약관은 주민번호 대체 본인인증서비스(이하 "서비스")를 제공하는 주식회사 케이티(이하 "회사")와 이용 고객(이하 "이용자")간에 서비스 제공에 관한 이용조건 및 절차 등 기타 필요한 사항을 규정함을 목적으로 합니다.
제2조 (용어의 정의)
본 약관에서 사용하는 용어의 정의는 다음과 같습니다.
1. "본인인증서비스"라 함은 이용자가 인터넷상에서 본인명의의 휴대폰을 이용하여, 주민등록번호 입력 없이도 본인임을 안전하게 식별 및 확인해 주는 서비스를 말합니다.
2, "이용자"라 함은 회사 또는 인증 대행기관에서 제공하는 서비스의 이용을 위해 자신의 본인확인정보를 회사, 인증대행 기관, 본인확인기관 등에게 제공하고, 본인임을 확인 받고자 하는 자를 말합니다.
3. "본인확인정보"라 함은 이용자가 입력한 생년월일, 성별, 성명, 내/외국인, 휴대폰번호, 통신사 등 본인 식별에 필요한 이용자의 정보를 말합니다.
4. "중복가입확인정보"라 함은 웹사이트에 가입하고자 하는 이용자의 중복확인을 위해 제공되는 정보를 말합니다.
5. "연계정보"라 함은 인터넷사업자의 온 • 오프라인 서비스 연계 등의 목적으로 이용자를 식별하기 위해 제공되는 정보를 말합니다.
6. "본인확인기관"이라 함은 주민등록번호를 사용하지 아니하고 본인을 확인하는 방법 또는 서비스를 제공하는 자로 방송통신위원회로부터 본인확인기관으로 지정을 받은 자를 의미합니다.
7. "인증 대행기관"이라 함은 회사를 대신하여 서비스의 제공 및 지원 등의 중계 업무를 담당하는 곳으로회사와 업무지원에 대한 계약이 완료되어 인터넷사업자에 서비스를 제공하는 사업체를 말합니다.
8. "인터넷사업자"라 함은 인터넷을 이용하여 정보를 제공하거나, 정보의 제공을 매개하는 일을 업으로 하는자로 회사 또는 인증 대행기관과의 서비스 계약을 통해 운영하며, 인터넷 웹사이트의 이용자에 대한 본인확인정보를 제공받는 사업체를 말합니다.
9. "접근매체"라 함은 본인인증을 함에 있어 이용자 본인인증의 진실성과 정확성을 확보하기 위하여 사용되는 수단 또는 정보로서 회사에 등록된 이용자의 전화번호, 이용자의 생체정보, 이상의 수단이나 정보를 사용하는데 필요한 비밀번호 등을 말합니다.
제3조 (약관의 명시 및 변경)
1. 본 약관은 이용자에게 서비스 화면에 게시하거나, 기타의 방법으로 공지하는 것으로 효력이 발생합니다.
2. 회사는 약관의 규제에 관한 법률 및 기타 관련 법령에 위배되지 않는 범위에서 본 약관의 내용을 개정 할 수 있으며, 변경된 경우에는 제1항과 같은 방법으로 공지합니다. 다만 "이용자"의 권리와 의무에 관한 중요한 사항은 변경된 내용의 시행 15일 이전에 공지합니다.
3. 이용자는 개정된 약관 사항에 동의하지 않을 권리가 있으며, 개정된 약관에 동의하지 않는 경우, 본 서비스의 이용을 중단하고 이용 계약을 해지할 수 있습니다. 회원이 회사의 전항 단서에 따른 약관의 불리한 변경에 대하여 적용예정일까지 회사에게 부동의 의사를 표시하지 않거나 이용계약을 해지하지 않은 경우 변경된 약관을 승인한 것으로 봅니다.
제4조 (접근매체의 관리 등)
1. 회사는 서비스 제공 시 접근매체를 이용하여 이용자의 신원, 권한 및 거래지시의 내용 등을 확인 할 수 있습니다.
2. 이용자는 접근매체를 제3자에게 대여하거나 사용을 위임하거나 양도 또는 담보 목적으로 제공할 수 없습니다.
3. 이용자는 자신의 접근매체를 제3자에게 누설 또는 노출하거나 방치하여서는 안되며, 접근매체의 도용이나 위조 또는 변조를 방지하기 위해 충분한 주의를 기울여야 합니다.
4. 회사가 접근매체의 발급주체가 아닌 경우에는 접근매체의 위조나 변조로 발생한 사고로 인하여 이용자에게 발생한 손해에 대하여 배상책임이 없습니다.
제5조 (서비스 안내)
1. 서비스는 이용자가 주민등록번호의 입력 없이, 본인명의로 된 휴대폰정보를 이용하여 본인 식별 또는 본인 확인이 가능한 생년월일 기반의 주민등록번호 대체 휴대폰인증 서비스 입니다.
2. 회사는 인증 대행기관을 통해 인터넷사업자에게 서비스를 제공하며, 인터넷사업자는 회원가입, ID/PW찾기, 성인인증, 기타 본인확인이 필요한 경우 이용자에게 서비스를 제공 합니다.
3. 이용자는 자신의 생년월일, 성명, 성별, 내/외국인, 휴대폰번호, 통신사 등의 정보를 입력하며, 입력한 정보가 일치한 경우에는 해당 휴대폰번호로 수신된 1회성 비밀번호(승인번호)를 정확하게 입력하는 것으로 본인 식별 또는 본인 확인이 이루어 집니다.
4. 본인 인증이 완료 된 이용자에 대해서는 본인확인정보와 중복가입확인정보 및 연계정보가 인터넷사업자에게 제공되며, 인터넷사업자는 중복가입확인정보 또는 연계정보 등을 이용하여 이용자 관리 및 컨텐츠를 제공ㆍ운영 합니다.
제6조 (서비스 제공시간)
1. 서비스의 이용은 연중무휴 1일 24시간을 원칙으로 합니다. 다만, 정기 점검 및 기타 기술상의 이유로 서비스가 일시 중지될 수 있고 또한, 운영상의 목적으로 회사가 정한 기간에도 일시 중지될 수 있습니다.
2. 회사는 효율적인 업무 수행을 위하여 필요하다고 판단하는 경우 서비스를 일정 범위로 분할 하여 각 범위 별로 이용가능 시간을 달리 정할 수 있으며, 이 경우 그 내용을 공지 합니다.
제7조 (회사의 권리와 의무)
1. 회사는 이용자가 서비스 이용시 이용약관이나 안내사항 등을 확인하지 않아 발생한 손해, 또는 접근매체를 통해 알 수 있었음에도 불구하고, 이용자 자신의 접근매체를 누설 또는 노출하거나 방치한 손해 등 이용자의 부주의에 기인한 손해에 대하여 배상책임이 없습니다.
2. 회사는 서비스 제공과 관련하여 인지한 이용자의 본인확인정보를 본인의 승낙 없이 제3자에게 누설하거나 배포하지 않습니다. 단, 국가기관의 요구가 있는 경우, 범죄에 대한 수사상의 목적이 있는 경우 등 기타 관계 법령에서 정한 절차에 따른 요청이 있는 경우에는 그러하지 않습니다.
3. 회사는 이용자에게 안정적인 서비스 제공을 위하여 지속적으로 서비스의 예방점검, 유지보수 등을 이행하며, 서비스의 장애가 발생하는 경우, 이를 지체 없이 수리 및 복구합니다.
4. 회사는 아래와 같은 사유가 발생하는 경우 이용자에 대하여 서비스를 제한할 수 있습니다.
가. 다른 사람의 명의사용 등 이용자 등록 시 허위로 신청하는 경우
나. 이용자 등록 사항을 누락하거나 오기하여 신청하는 경우
다. 대포폰(이동전화 서비스 본래의 목적과는 달리 불법대출 등 부정사용을 목적으로 타인 명의 무단 개통 또는 명의자를 교사하여 개통하는 휴대전화)을 이용하는 경우
라. 타인의 명의를 도용한 사실이 있거나 명의 도용을 이유로 처벌받은 경우
마. 불법 복제와 관련된 사실이 있거나 처벌 받은 경우
바. 기타 시장질서를 교란시키는 불법행위에 해당하는 경우
5. 회사는 다음 각 호에 해당하는 경우 서비스의 전부 또는 일부를 중지할 수 있습니다. 회사는 회사의 고의 또는 과실이 없는 한 배상책임이 없습니다. 다음 각 호에 의하여 본 서비스를 중지하는 경우에는 회사가 제3조 제1항에서 정한 방법으로 회원에게 고지합니다. 다만, 회사가 통제할 수 없는 사유로 인한 본 서비스의 중단(회사 또는 운영자의 고의 및 과실이 없는 디스크 장애, 시스템 다운 등)으로 인하여 사전 통지가 불가능한 경우에는 그러하지 아니합니다.
가. 컴퓨터 등 정보통신설비의 보수점검 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우
나. 서비스를 위한 설비의 보수 등 공사로 인해 부득이한 경우
다. 서비스 업그레이드 및 시스템 유지보수 등을 위해 필요한 경우
라. 정전, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 서비스 이용에 지장이 있는 경우
마. 회원이 회사의 본 서비스 운영을 방해하는 경우
바. 기타 천재지변, 국가비상사태 등 불가항력적 사유가 있는 경우
제8조 (이용자의 의무)
1. 이용자는 서비스를 이용함에 있어서 다음 각호에 해당하는 행위를 하여서는 안되며, 회사는 위반 행위에 따르는 일체의 법적 책임을 지지 않습니다.
① 타 이용자의 본인확인정보를 부정하게 사용 및 도용하는 행위
② 회사의 저작권, 제3자의 저작권 등 기타 권리를 침해하는 행위
③ 범죄 행위
④ 기타 관련 법령에 위배되는 행위
2. 이용자는 본 약관에서 규정하는 사항과 서비스에 대한 이용안내 또는 주의사항 등을 준수하여야 합니다.
제9조 (본인인증 정보의 제공금지)
회사는 서비스를 제공함에 있어 취득한 이용자의 정보 또는 자료를 이용자의 동의 없이 제3자에게 제공, 누설하거나 업무상 목적 외에 사용하지 않습니다.
제10조 (서비스의 안정성 확보)
1. 회사는 서비스의 안전성과 신뢰성을 확보하기 위하여 업무처리지침의 제정 및 시행, 정보 처리시스템 및 전산자료의 관리 등의 관리적 조치와 모니터링 체계 및 해킹방지시스템 구축 및 운영 등의 기술적 조치를 취해야 합니다.
2. 회사는 서버 및 통신기기의 정상작동여부 확인을 위하여 정보처리시스템 자원 상태의 감시, 경고 및 제어가 가능한 모니터링 체계를 갖추어야 합니다.
3. "회사"는 해킹 침해 방지를 위하여 다음 각 호의 시스템 및 프로그램을 설치하여 운영합니다.
① 침입차단시스템 설치
② 침입탐지시스템 설치
③ 그 밖에 필요한 보호장비 또는 암호프로그램 등 정보보호시스템 설치
4. "회사"는 컴퓨터바이러스 감염을 방지하기 위하여 다음 각 호를 포함한 대책을 수립, 운영하고 있습니다.
① 출처, 유통경로 및 제작자가 명확하지 아니한 응용프로그램은 사용을 자제하고 불가피할 경우에는 컴퓨터바이러스 검색프로그램으로 진단 및 치료 후 사용할 것
② 컴퓨터바이러스 검색, 치료 프로그램을 설치하고 최신 버전을 유지할 것
③ 컴퓨터바이러스 감염에 대비하여 방어, 탐색 및 복구 절차를 마련할 것
제11조 (이용자의 개인정보보호)
회사는 관련법령이 정하는 방에 따라서 이용자의 개인정보를 보호하기 위하여 노력하며, 이용자의 개인정보에 관한 사항은 관련 법령 및 회사가 정하는 개인정보취급방침에 정한 바에 따릅니다.
제12조 (개인정보의 처리)
회사는 수집된 개인정보의 취급 및 관리 등의 업무를 스스로 수행함을 원칙으로 하나, 필요한 경우 업무의 일부 또는 전부를 회사가 선정한 사업자에게 위탁할 수 있습니다.
1. 서비스 이용 시 이용자의 개인정보 수집 및 이용 동의에 따라 인터넷사업자가 필요로 하는 이용자 식별정보(중복가입확인정보, 연계정보)의 생성 및 제공을 위하여 관련 정보를 타 본인확인기관에게 제공할 수 있으며, 수집된 식별정보(중복가입확인정보, 연계정보)는 본인 식별 및 확인 위한 목적으로 회사 또는 인증 대행기관을 통해 인터넷사업자에게 제공할 수 있습니다.
2. 개인정보 처리 및 위탁 등에 관한 사항은 관련법령 및 회사가 정하는 개인정보취급방침에 정한 바에 따릅니다.
제13조 (약관 외 준칙)
본 약관에 명시되지 아니한 사항에 대해서는 정보통신망 이용 촉진 및 정보보호 등에 관한 법률, 개인정보보호법 등 기타 관련법령 또는 상관례에 따릅니다.
부칙
(시행일) 이 약관은 공지한 날로부터 시행합니다.


LGU+ 본인확인 이용 약관

http://www.uplus.co.kr/css/rfrm/prvs/RetrieveUbDnUseTermsPop_7.hpi

      </Typography>
      <hr />
    </>
  );
}
function JeonMoon2(props) {
  const classes = props.useStyles();
  const [showResults, setShowResults] = React.useState(false);
  const onView = (e) => {
    e.preventDefault();
    setShowResults(!showResults);
  };
  return (
    <>
      <FormGroup row>
        <FormControlLabel
          control={
            <Checkbox
              checked={props.JeonMoon2}
              disabled={props.SelfCertification}
              onChange={(e) => {
                props.onChangeJeonMoon2Yn(e.target.checked);
              }}
              name="Marketing"
            />
          }
          label={
            <Typography className={classes.TypographyFont}>
              [필수]통신사 이용약관 동의
            </Typography>
          }
        />
        <Button
          className={classes.Button}
          variant="text"
          color="primary"
          type="submit"
          onClick={onView}
          startIcon={<VisibilityIcon />}
        >
          내용보기
        </Button>
      </FormGroup>

      <hr />
      {showResults ? <ViewResult /> : null}
    </>
  );
}
export default JeonMoon2;
